import { render, staticRenderFns } from "./BlackHoleStateRow.vue?vue&type=template&id=6376ce31&scoped=true"
import script from "./BlackHoleStateRow.vue?vue&type=script&lang=js"
export * from "./BlackHoleStateRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376ce31",
  null
  
)

export default component.exports